import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";

import { markAsTouched, updateValueAndValidity } from "@dffedb/forms";
import { DffRouteParams } from "@dffedb/router";
import { ToastService } from "@dffedb/ui";
import { DffGroupedContent } from "@dffedb/util";
import { RedirectService } from "@e-forsyning/common/router";
import { EforsyningUrlService } from "@e-forsyning/common/util";

import { IFlyttemeddelelse } from "../model/flyttemeddelelse.model";
import { FlyttemeddelelseKvitteringMailService } from "../shared/flyttemeddelelse-kvittering-mail.service";
import { FlyttemeddelelseKvitteringService } from "../shared/flyttemeddelelse-kvittering.service";
import { FlyttemeddelelseKvitteringFormBuilder } from "./flyttemeddelelse-kvittering.form-builder";

@Component({
    templateUrl: "./flyttemeddelelse-kvittering.component.html",
    styleUrls: ["./flyttemeddelelse-kvittering.component.scss"]
})
export class FlyttemeddelelseKvitteringComponent implements OnInit {
    private flyttemeddelelse: IFlyttemeddelelse;
    public erSpinnerSynlig = false;
    public kvittering$: Observable<DffGroupedContent>;
    public formGroup: UntypedFormGroup;
    public erMailSendt = false;
    public sideTekst: string;

    constructor(
        private readonly routeParams: DffRouteParams,
        private readonly toastService: ToastService,
        private readonly redirectService: RedirectService,
        private readonly mailService: FlyttemeddelelseKvitteringMailService,
        private readonly kvitteringService: FlyttemeddelelseKvitteringService,
        private readonly urlService: EforsyningUrlService
    ) {
        this.formGroup = FlyttemeddelelseKvitteringFormBuilder.opretFormGroup();
    }

    public async ngOnInit(): Promise<void> {
        try {
            const data = this.routeParams.get("data");
            this.flyttemeddelelse = JSON.parse(atob(data));
            this.kvittering$ = this.kvitteringService.genererKvittering(this.flyttemeddelelse);

            const mineDokumenterUrl = await this.urlService.hentAbsolutUrl("mine-dokumenter");
            this.sideTekst = `<p>Bemærk at når vi registrerer din flytning, forsvinder din adgang til E|Forsyning.</p>
                              <p>Du kan derfor med fordel downloade vigtige dokumenter fra menupunktet 
                              <a href="${mineDokumenterUrl}">Mine dokumenter</a> til senere brug.</p>`;
        } catch (exception) {
            this.redirectService.redirectTilInstallationer();
        }
    }

    public async opretKvitteringsmail(): Promise<void> {
        markAsTouched(this.formGroup);
        updateValueAndValidity(this.formGroup);

        if (!this.formGroup.valid) {
            return;
        }

        this.erSpinnerSynlig = true;
        try {
            const mailadresse = this.formGroup.controls.mailadresse.value;
            await this.mailService.sendMail(this.flyttemeddelelse, mailadresse);
            this.toastService.visInfo(`Der er sendt en mail til ${mailadresse}.`);
            this.erMailSendt = true;
        } finally {
            this.erSpinnerSynlig = false;
        }
    }
}
